const { default: axios } = require("axios");
import { createApp } from 'vue';
import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

var gap = document.getElementById("gap").clientWidth;
var gap2x = document.getElementById("gap-2x").clientWidth;
var mVert = document.getElementById("m-vert").clientWidth;
var mVertSlim = document.getElementById("m-vert-slim").clientWidth;
var widthMargin = document.getElementById("width-margin").clientWidth;
var articleWidth = document.getElementById("article-width").clientWidth;

window.addEventListener('load',function() {
    
    var ff = createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                waitForApi: false,
            }
        },
        methods: {
        },
        computed: {
            isTouch: function() {
                return supportsTouch;
            }
        },
        mounted: function() {
        }
    }).mount('#app');

    new Swiper('.wp-block-ff-hero .swiper-container',{
        modules: [Autoplay, Pagination],
        lazy: true,
        loop: true,
        autoplay: {
            delay: 2000,
        },
        on: {
            init: function() {
            },
            transitionEnd: function() {
            }
        },
        navigation: {
            prevEl: '',
            nextEl: ''
        },
        pagination: {
            el: '',
            type: 'bullets',
        },
    });

    document.querySelectorAll('.wp-block-hlp-accordion').forEach(function(el) {
        el.addEventListener('click', function() {
            var h = el.querySelector('.inner>div').clientHeight;
            if (el.classList.contains('open')) {
                el.querySelector('.inner').style.height = '0px';
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
            }
        });
    });

    document.querySelectorAll('.wp-block-hlp-prozesse-lang .prozess').forEach(function(el) {
        el.addEventListener('click', function() {
            document.querySelectorAll('.wp-block-hlp-prozesse-lang .prozess:not(#'+el.id+')').forEach(function(elOther) {
                    elOther.querySelector('.inner').style.height = '0px';
                    elOther.classList.remove('open');
                    elOther.parentElement.classList.remove('open');
            });
            var h = el.querySelector('.inner>div').clientHeight;
            var elParent = el.parentElement;
            if (elParent.classList.contains('open')) {
                el.querySelector('.inner').style.height = '0px';
                elParent.classList.remove('open');
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
                elParent.classList.add('open');
            }
        });
    });

    document.getElementById("trigger").addEventListener("click", function (el) {
        var el = document.getElementById("trigger");
        if (el.classList.contains("open")) {
            el.classList.remove("open");
            document.querySelector("body").classList.remove("scroll-lock");
            document.getElementById("mobile_menu").classList.remove("open");
        } else {
            el.classList.add("open");
            document.querySelector("body").classList.add("scroll-lock");
            document.getElementById("mobile_menu").classList.add("open");
        }
    });

    window.addEventListener('scroll', function() {
        if (window.scrollY > 0) {
            if(document.querySelector('header').classList.contains('scrolled')) {
                return;
            }
            document.querySelector('header').classList.add('scrolled');
        } else {
            document.querySelector('header').classList.remove('scrolled');
        }
    });

    var lastScrollTop = 0;
    var cta = document.querySelector('.cta');
    window.addEventListener('scroll', function() {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if(st > 24) {
            this.document.querySelector('header').classList.add('scrolled');   
        } else {
            this.document.querySelector('header').classList.remove('scrolled');
        }
        if (st > lastScrollTop){
            cta.classList.remove('show');
        } else {
            cta.classList.add('show');
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }, false);

    window.setInterval(() => {
    const isMobile = window.innerWidth <= 768;
    const iframe = document.querySelector(".mf-notification-iframe");
        if(iframe) {
            iframe.contentWindow.postMessage({ isMobile }, "*");
        }
    }, 246);

})